import { IProductNavigation } from '@adaptiva/core/app-shell';
import { Licensing } from '@adaptiva/core/licensing'; 

const _productName: string = Licensing.Products.Deprecated.UXM;
const _baseUrl: string = Licensing.PRODUCT_ROUTES.get(_productName);

export const UXM_PRODUCT_NAVIGATION: IProductNavigation = {
	productName: _productName,
	route: _baseUrl,
	sidenav: {
		productName: _productName,
		sections: [{
			items: [
				{
					display: 'Home',
					route: _baseUrl,
					icon: 'faHomeOutline',
				},
				{
					display: 'Category Scores',
					route: `/${_baseUrl}/category-overview`,
					icon: 'faPollPeopleOutline',
				},
				{
					display: 'Metric Scores',
					route: `/${_baseUrl}/metric-overview`,
					icon: 'faUserChartOutline',
				},
				{
					display: 'Location Scores',
					route: `/${_baseUrl}/location-overview`,
					icon: 'faMapMarkedAltOutline',
				},
				{
					display: 'Device Scores',
					route: `/${_baseUrl}/device-overview`,
					icon: 'faPhoneLaptopOutline',
				},
				{
					display: 'Administration',
					route: `/${_baseUrl}/administration`,
					icon: 'faUserCogOutline',
				},
				{
					display: 'Surveys',
					route: '/surveys',
					icon: 'faQuestionCircleOutline',
					linkedRoutes: ['/surveys/edit/:id']
				}
			]
		}]
	}
};
